import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Space, Typography } from 'antd';
import currencyFormat from 'utils/currencyFormat';

function FlashCard({ icon, title, data }) {
  const template = data.map((i) => {
    return (
      <Space direction="vertical" key={i.label}>
        <Typography.Text style={{ fontSize: '12px', letterSpacing: '1px' }}>
          {i.label}
        </Typography.Text>
        <Typography.Text style={{ fontSize: '20px', fontWeight: '500', letterSpacing: '1px' }}>
          {currencyFormat(i.value, true, true)}
        </Typography.Text>
      </Space>
    );
  });
  return (
    <Row
      style={{
        background:
          'transparent linear-gradient(119deg, #FFFFFF 35%, #E5FDFD 100%) 0% 0% no-repeat padding-box',
        boxShadow: '0px 1px 6px #00000014',
        borderRadius: '10px',
        padding: '10px'
      }}
    >
      <Col span={3}>{icon}</Col>
      <Col span={21}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Space>
            <Typography.Text style={{ fontSize: '18px', fontWeight: '600', letterSpacing: '1px' }}>
              {title}
            </Typography.Text>
          </Space>
          <Space direction="horizontal" style={{ width: '100%', justifyContent: 'space-between' }}>
            {template}
          </Space>
        </Space>
      </Col>
    </Row>
  );
}

FlashCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  data: PropTypes.instanceOf(Object).isRequired
};

export default FlashCard;
